module.exports = __webpack_public_path__ + "static/media/blue_search.d47fb13d.svg";